import React from 'react';

function TableRows({rowsData, deleteTableRows, handleChange}) {
    return(
        
    rowsData.map((data, index)=>{

        const {partNumber,reasonForScrap,quantity,PO_SA_Number,QN_RFA_Number,serialNumber}= data;

    return(
        <tr key={index}>
            <td>{index+1}</td>
            <td>
                <input type="text" value={partNumber} onChange={(evnt)=>(handleChange(index, evnt))} name="partNumber" class="form-control" required/>
            </td>
            <td>
                <select id="reasonForScrap" name="reasonForScrap" onChange={(evnt)=>(handleChange(index, evnt))} value={reasonForScrap} class="form-control" required>
                    <option value="">-- Please Select --</option>
                    <option value="Engineering Change">Engineering Change</option>
                    <option value="Excess/Obsolete">Excess/Obsolete</option>
                    <option value="Latent Defect (provide RM supplier name in comments field)">Latent Defect (provide RM supplier name in comments field)</option>
                    <option value="Producibility">Producibility</option>
                    <option value="RFA eQN/QN">RFA eQN/QN</option>
                    <option value="RFA eQuest/QN">RFA eQuest/QN</option>
                    <option value="Tooling">Tooling</option>
                    <option value="Other (specify in comments field)">Other (specify in comments field)</option>
                </select>                
            </td>
            <td>
                <input type="number" value={quantity}  onChange={(evnt)=>(handleChange(index, evnt))} name="quantity" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={PO_SA_Number}  onChange={(evnt)=>(handleChange(index, evnt))} name="PO_SA_Number" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={QN_RFA_Number}  onChange={(evnt)=>(handleChange(index, evnt))} name="QN_RFA_Number" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={serialNumber}  onChange={(evnt)=>(handleChange(index, evnt))} name="serialNumber" class="form-control" required/> 
            </td>
            <td>
                <button class="btn btn-outline-danger" onClick={()=>(deleteTableRows(index))}>x</button>
            </td>
        </tr>
            )
        })
   
    )
    
}
export default TableRows;